export interface FaqItem {
  question: string
  answer: string
}

export const faqs: FaqItem[] = [
  {
    question: "Come accedo a Yoga Kit Pro™ dopo l'acquisto?",
    answer:
      'Riceverai accesso immediato via email con il link di download. Potrai scaricare tutti i 6 volumi e i 5 bonus in formato PDF. Nessuna attesa, nessun passaggio complicato.',
  },
  {
    question: 'Per quali insegnanti è Yoga Kit Pro™?',
    answer:
      'È perfetto per insegnanti di yoga in Italia di qualsiasi livello — principianti, intermedi o esperti. Se stai già insegnando o stai per iniziare, questo kit ti serve. Le sequenze coprono tutti gli stili principali.',
  },
  {
    question: 'Posso modificare e personalizzare il materiale?',
    answer:
      'Sì, completamente. I PDF sono tuoi. Puoi stamparli, annotarli, modificarli, adattarli al tuo stile. Non è contenuto bloccato — è tuo per usarlo come preferisci.',
  },
  {
    question: 'In quale formato?',
    answer:
      'Tutto in formato PDF. Scarica, salva nel tuo computer, stampa se vuoi, accedi da qualsiasi dispositivo. Nessuna piattaforma, nessuna app complicata. Semplicemente PDF pronti.',
  },
  {
    question: 'Cosa succede se non trovo utile il materiale?',
    answer:
      'Hai 7 giorni per pensarci. Se non sei soddisfatta, chiedi il rimborso completo. Nessuna domanda, nessun problema. Ma siamo sicuri che ti piacerà — la maggior parte degli insegnanti che lo provano capisce il valore già dalla prima lezione.',
  },
  {
    question: 'Ricevo aggiornamenti futuri?',
    answer:
      'Con il prezzo di lancio di €19, accedi alla versione attuale di Yoga Kit Pro™. È un acquisto una tantum, non un abbonamento. Se in futuro verranno aggiunti nuovi volumi, saranno prodotti separati.',
  },
  {
    question: 'Vale anche per insegnanti online?',
    answer:
      'Perfettamente. Le sequenze sono indipendenti dal formato di insegnamento. Che insegni in studio, online via Zoom o in entrambi, Yoga Kit Pro™ funziona.',
  },
]
